module.exports = __webpack_public_path__ + "static/media/icon_42.9533a7c1.svg";